var DialogUpdatedModule = /** @class */ (function () {
    function DialogUpdatedModule() {
    }
    return DialogUpdatedModule;
}());
export { DialogUpdatedModule };
